var map = {
	"./en-lproj/ToolInfos.xml": 191,
	"./ru-lproj/ToolInfos.xml": 1038
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1332;



//////////////////
// WEBPACK FOOTER
// ./src/resources/localizable ^\.\/.*\-lproj\/ToolInfos\.xml$
// module id = 1332
// module chunks = 0